import {useRef, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Form, Formik} from "formik";
import {handleDatePickedFrom, handleDatePickedTo} from "../../Helpers/utils";
import {FormSchema} from "./controlFormValidationSchema";
import {BlockUnsavedForm} from "../BlockUnsavedForm/BlockUnsavedForm";
import {FormActionButtons} from "../FormActionButtons/FormActionButtons";
import {unblockRoute} from "../../Services/BlockChangeRoute";
import SelectCustom from "../SelectCustom/SelectCustom";
import FieldsetCustom from "../FieldsetCustom/FieldsetCustom";
import RadioCustom from "../RadioCustom/RadioCustom";
import DatePickerCustom from "../DatePickerCustom/DatePickerCustom";
import {compareByCode} from '../../Helpers/utils';
import {EditControlSource} from "../../enums/editControlSource";
import WysiwygEditor from "../WysiwygEditor/WysiwygEditor";

export const ControlForm = (props) => {
    const onKeyDown = (ev) => {
        // Prevent submitting form with ENTER, when there are multiple types of form fields
        if ((ev.charCode || ev.keyCode) === 13) {
            ev.preventDefault();
        }
    };

    const fromDateRef = useRef();
    const toDateRef = useRef();
    const selectProjectRef = useRef();
    const selectKindRef = useRef();
    const selectControllerRef = useRef();
    const selectListRef = useRef();

    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        props.getProjects(searchTerm);
      }, 500)
  
      return () => clearTimeout(delayDebounceFn)
    }, [searchTerm])

    
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        project: props.selectedProject || [],
        kinds: props.selectedKinds || [],
        dateFrom: props.selectedDateFrom,
        dateTo: props.selectedDateTo,
        controllers: props.selectedControllers || [],
        teamLeader: props.selectedTeamLeader || null,
        controlList: props.selectedControlList || [],
        type: props.selectedType,
        mode: props.selectedMode,
        remarks: props.remarks || ''
      }}
      validationSchema={FormSchema}
      onSubmit={(values) => {
        unblockRoute();
        props.handleSaveControl(values);
      }}
    >
      {({ values, errors, touched, setFieldValue }) => {
        values?.controlList?.forEach((cl) => cl.codeAndName = `${cl.code} - ${cl.name}`)?.sort(compareByCode);
        
        return (
          <>
            <BlockUnsavedForm />
            <Form onKeyDown={onKeyDown}>
              {props.controlNumber && (
                <div className='row mb-3'>
                  <div className='col-12'>
                    <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#333' }}>
                      Dotyczy: {props.controlNumber}
                    </div>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='col-md-6'>
                  <SelectCustom
                    searchFn={(event) => {
                      const { search } = event.state;
                      setSearchTerm(search);
                    }}
                    invalid={errors.project && touched.project}
                    error={errors.project && touched.project && errors.project}
                    errorId='projectAlert'
                    label='Projekt'
                    id='projectSelectId'
                    dropdownId='projectDropdownId'
                    values={values.project}
                    labelField='number'
                    placeholder='Projekt'
                    valueField='number'
                    options={props.projects}
                    onChange={(value) => setFieldValue("project", value)}
                    disabled={
                      props.projectDisabled || props.isControlInProgress || props.isWaiting
                    }
                    parentRef={selectProjectRef}
                  />
                  {values.project && values.project.length > 0 && values.project[0] && (
                    <div className='mt-2' style={{ fontSize: '0.9rem', color: '#555' }}>
                      {values.project[0].beneficiaryName && (
                        <div><strong>Nazwa beneficjenta:</strong> {values.project[0].beneficiaryName}</div>
                      )}
                      {values.project[0].beneficiaryIdentityNumber && (
                        <div><strong>Identyfikator beneficjenta:</strong> {values.project[0].beneficiaryIdentityNumber}</div>
                      )}
                      {values.project[0].title && (
                        <div><strong>Tytuł projektu:</strong> {values.project[0].title}</div>
                      )}
                    </div>
                  )}
                </div>
                <div className='col-md-6'>
                  <SelectCustom
                    invalid={errors.kinds && touched.kinds}
                    error={errors.kinds && touched.kinds && errors.kinds}
                    errorId='kindAlert'
                    label='Rodzaj kontroli'
                    id='kindsSelectId'
                    dropdownId='kindsDropdownId'
                    values={values.kinds.filter(option => option['dictName'].includes('slownik_rodzaju_kontroli'))}
                    labelField='description'
                    placeholder='Rodzaj kontroli'
                    valueField='description'
                    options={props.kinds.filter(option => option['dictName'].includes('slownik_rodzaju_kontroli'))}
                    onChange={(value) => {
                      setFieldValue("kinds", value.filter(option => option['dictName'].includes('slownik_rodzaju_kontroli')));
                    }}
                    multi
                    isMulti
                    disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                    parentRef={selectKindRef}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <FieldsetCustom
                    legend='Typ kontroli'
                    error={
                      errors.type && touched.type && errors.type.description
                    }
                    errorId='typeAlert'
                    invalid={errors.type && touched.type}
                    row
                  >
                    {props.types.length > 0 && (
                      <>
                        <RadioCustom
                          label={props.types[0].description}
                          id='radioType0Id'
                          value='0'
                          checked={
                            values.type?.description ===
                            props.types[0].description
                          }
                          onChange={() => setFieldValue("type", props.types[0])}
                          disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                          name='typeRadio'
                        />
                        <RadioCustom
                          label={props.types[1].description}
                          id='radioType1Id'
                          value='1'
                          checked={
                            values.type?.description ===
                            props.types[1].description
                          }
                          onChange={() => setFieldValue("type", props.types[1])}
                          disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                          name='typeRadio'
                        />
                      </>
                    )}
                  </FieldsetCustom>
                </div>
                <div className='col-md-6'>
                  <FieldsetCustom
                    legend='Tryb kontroli'
                    error={
                      errors.mode && touched.mode && errors.mode.description
                    }
                    errorId='modeAlert'
                    invalid={errors.mode && touched.mode}
                    row
                  >
                    {props.modes.length > 0 && (
                      <>
                        <RadioCustom
                          label={props.modes[0].description}
                          id='radioMode0Id'
                          value='0'
                          checked={
                            values.mode?.description ===
                            props.modes[0].description
                          }
                          onChange={() => setFieldValue("mode", props.modes[0])}
                          disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                          name='modeRadio'
                        />
                        <RadioCustom
                          label={props.modes[1].description}
                          id='radioMode1Id'
                          value='1'
                          checked={
                            values.mode?.description ===
                            props.modes[1].description
                          }
                          onChange={() => setFieldValue("mode", props.modes[1])}
                          disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                          name='modeRadio'
                        />
                      </>
                    )}
                  </FieldsetCustom>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <FieldsetCustom legend='Planowany termin kontroli' row>
                    <DatePickerCustom
                      label='Data rozpoczęcia'
                      datePickerId='date_picker_from'
                      invalid={errors.dateFrom && touched.dateFrom}
                      error={
                        errors.dateFrom && touched.dateFrom && errors.dateFrom
                      }
                      errorId='dateAlertFrom'
                      selected={values.dateFrom}
                      dateName='rozpoczęcia'
                      onChange={(e) => {
                        const { dateFrom, dateTo } = handleDatePickedFrom(e);
                        setFieldValue("dateFrom", dateFrom);
                        setFieldValue("dateTo", dateTo);
                      }}
                      parentRef={fromDateRef}
                      disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                    />
                    <DatePickerCustom
                      label='Data zakończenia'
                      datePickerId='date_picker_to'
                      invalid={errors.dateTo && touched.dateTo}
                      error={errors.dateTo && touched.dateTo && errors.dateTo}
                      errorId='dateAlertTo'
                      selected={values.dateTo}
                      onChange={(e) =>
                        setFieldValue("dateTo", handleDatePickedTo(e))
                      }
                      parentRef={toDateRef}
                      dateName='zakończenia'
                      disabled={(props.editControlSource && props.editControlSource !== EditControlSource.MANAGE_ACTIVE && props.editControlSource !== EditControlSource.MANAGE_PLANNED) || props.isWaiting}
                    />
                  </FieldsetCustom>
                </div>
                <div className='col-md-6'>
                  <SelectCustom
                    key={JSON.stringify(values.controllers)}
                    invalid={errors.controllers && touched.controllers}
                    error={
                      errors.controllers &&
                      touched.controllers &&
                      errors.controllers
                    }
                    errorId='controllersAlert'
                    label='Zespół kontrolujący'
                    id='controllersSelectId'
                    dropdownId='userDropdownId'
                    values={values.controllers}
                    labelField='customLabel'
                    placeholder='Użytkownicy'
                    valueField='login'
                    options={props.controllers}
                    searchFn={({ state, methods }) => {
                      const regexp = new RegExp(methods.safeString(state.search), 'i');
                      return methods.sortBy().filter(item => regexp.test(item.firstAndLastName));
                    }}
                    onChange={(controllers) => {
                      const uniqueControllers = [];
                      for (let i = controllers.length - 1; i >= 0; i--) {
                        const controller = controllers[i];
                        if (!uniqueControllers.some((item) => item.login === controller.login)) {
                          uniqueControllers.unshift(controller);
                        }
                      }
                      setFieldValue("controllers", uniqueControllers);
                      
                      // Clear team leader if they're no longer in the team
                      const currentTeamLeader = values.teamLeader;
                      if (currentTeamLeader && !uniqueControllers.some((c) => c.login === currentTeamLeader.login)) {
                        setFieldValue("teamLeader", null);
                      }
                    }}
                    isMulti
                    multi
                    containerClassName='select-container--in-row'
                    parentRef={selectControllerRef}
                    disabled={props.isWaiting}
                  />
                </div>

              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <SelectCustom
                    invalid={errors.controlList && touched.controlList}
                    error={
                      errors.controlList &&
                      touched.controlList &&
                      errors.controlList
                    }
                    errorId='listAlert'
                    label='Zastosowana lista sprawdzająca'
                    id='controlListSelectId'
                    dropdownId='controlListDropdownId'
                    values={values.controlList}
                    labelField='codeAndName'
                    placeholder='Listy sprawdzające'
                    valueField='code'
                    options={props.controlLists}
                    onChange={(values) => setFieldValue("controlList", values)}
                    disabled={(props.postControlDocuments && props.editControlSource === EditControlSource.MANAGE_ACTIVE) || props.editControlSource === EditControlSource.MANAGE_DONE || props.isWaiting}
                    parentRef={selectListRef}
                    searchFn={({ state, methods }) => {
                      const regexp = new RegExp(methods.safeString(state.search), 'i');
                      return methods
                        .sortBy()
                        .filter((item) => regexp.test(item.code) || regexp.test(item.name));
                    }}
                  />
                </div>
                <div className='col-md-6'>
                  <SelectCustom
                    key={JSON.stringify(values.teamLeader || {})}
                    invalid={errors.teamLeader && touched.teamLeader}
                    error={
                      errors.teamLeader &&
                      touched.teamLeader &&
                      errors.teamLeader
                    }
                    errorId='teamLeaderAlert'
                    label='Kierownik zespołu kontrolującego'
                    id='teamLeaderSelectId'
                    dropdownId='teamLeaderDropdownId'
                    values={values.teamLeader ? [values.teamLeader] : []}
                    labelField='firstAndLastName'
                    placeholder='Kierownik zespołu'
                    valueField='login'
                    options={values.controllers || []}
                    onChange={(teamLeader) => {
                      const selectedTeamLeader = teamLeader.length > 0 ? teamLeader[teamLeader.length - 1] : null;
                      setFieldValue("teamLeader", selectedTeamLeader);
                    }}
                    disabled={!values.controllers || values.controllers.length === 0 || props.isWaiting}
                    containerClassName='select-container--in-row'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                    <WysiwygEditor
                      name="remarks"
                      label="Uwagi"
                      size={400}
                      value={values.remarks}
                      onChange={(e) => setFieldValue('remarks', e.target.value)}
                      readOnly={props.isWaiting}
                    />
                </div>
              </div>

              <FormActionButtons context='kontrolę' />
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

ControlForm.propTypes = {
  handleAbort: PropTypes.func.isRequired,
  handleSaveControl: PropTypes.func.isRequired,
};
